

























import { Component, Prop, Vue } from 'vue-property-decorator';

/**
 * Diadoc OIDC (FML-5vmy, Часть 1): индикатор статуса авторизации подписанта в Диадоке.
 * Презентационный, без бизнес-логики. Стейт маппится из EnsureSignerSessionResult
 * через signerAuthIndicatorState (services/signerSession). Размещение на странице и
 * биндинг @retry на startSignerLogin — Часть 2.
 */
type IndicatorState = 'authorized' | 'needs_auth' | 'auth_failed';

@Component
export default class SignerAuthIndicator extends Vue {
  @Prop({ required: true }) readonly state!: IndicatorState;

  get alertType(): string {
    if (this.state === 'authorized') return 'success';
    if (this.state === 'auth_failed') return 'error';
    return 'warning';
  }

  get textKey(): string {
    switch (this.state) {
      case 'authorized': return 'diadoc_auth_indicator_authorized';
      case 'auth_failed': return 'diadoc_auth_indicator_failed';
      default: return 'diadoc_auth_indicator_needs_auth';
    }
  }
}
